import { Box, Table, TableBody, TableCell, TableRow } from '@mui/material';
import Link from 'src/components/atoms/Link';
import StatusBadge from 'src/components/atoms/StatusBadge';
import ConfirmModal from 'src/components/containers/modals/ConfirmModal';
import { AgButton, AgText } from 'src/components/ui';
import { EntityType, entityTypes } from 'src/utils/entityTypes';
import type { ProductReservation } from './product.api';

function isEntityType(value: string): value is EntityType {
  return Object.values(EntityType).some((entityType) => entityType === value);
}

type ProductReservationWarningModalProps = {
  open: boolean;
  reservations: ProductReservation[];
  hasMore: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSeeMore: () => void;
};

export default function ProductReservationWarningModal({
  open,
  reservations,
  hasMore,
  onClose,
  onConfirm,
  onSeeMore,
}: ProductReservationWarningModalProps) {
  return (
    <ConfirmModal
      open={open}
      handleClose={onClose}
      handleConfirm={onConfirm}
      title="Product in Active Use"
      action="Confirm"
      prompt={
        <>
          <AgText size="16">By confirming, the product will be updated on the following active operations:</AgText>
          <Box sx={{ py: 2, maxHeight: '402px', overflowY: 'auto' }}>
            <Table>
              <TableBody>
                {reservations.map((reservation, i) => {
                  if (!isEntityType(reservation.type)) return null;

                  const entityType = entityTypes[reservation.type];
                  const route =
                    reservation.type === EntityType.LOT
                      ? typeof reservation.warehouseId === 'number'
                        ? entityTypes[EntityType.LOT].route({
                            slug: reservation.slug,
                            warehouseId: reservation.warehouseId,
                          })
                        : undefined
                      : entityTypes[reservation.type].route({ slug: reservation.slug });

                  return (
                    <TableRow key={i}>
                      <TableCell sx={{ py: 0.75 }}>{entityType.name}</TableCell>
                      <TableCell sx={{ py: 0.75, minWidth: '160px' }}>
                        {route ? (
                          <Link {...route} label={entityType.prefix + ' #' + reservation.slug} />
                        ) : (
                          entityType.prefix + ' #' + reservation.slug
                        )}
                      </TableCell>
                      <TableCell sx={{ py: 0.75, justifyItems: 'center' }}>
                        <StatusBadge status={reservation.status} />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <AgButton variant="ghost" onPress={onSeeMore} isDisabled={!hasMore}>
              See All
            </AgButton>
          </Box>
        </>
      }
    />
  );
}
